<div style="word-break: break-word;">
    <table style="border-collapse: separate; border-spacing: 0px 8px; width: 100%;">
        <tbody>
            @for (item of data.stringArray; track item) {
                <tr>
                    <td>
                        {{ item }}
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
